"use client";

import type { ThemeProviderProps } from "next-themes";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { useEffect, useState } from "react";

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return (
    <NextThemesProvider
      defaultTheme="dark"
      enableSystem={false}
      attribute="data-theme"
    >
      {children}
    </NextThemesProvider>
  );
};
